/**
 * Svg Icons
 *
 * Since we are using custom icons, we should map out the names for all icons
 * available in our app to be used universally
 *
 */
enum SvgIcons {
  HEART = 'heart',
  BELL = 'bell',
  ARROW = 'arrow',
  FEED = 'feed',
  MY_CIRCLE = 'my_circle',
  EXTERNAL_LINK = 'external_link',
  CHAT = 'chat',
  PRIVACY = 'privacy',
  CAVET = 'cavet',
  PROFILE = 'profile',
  FLAG = 'flag',
  SETTING = 'setting',
  SQUARE_CHECK = 'square_check',
  PUBLIC = 'PUBLIC',
  FILLED_ARROW = 'FILLED_ARROW',
  SHARE_CIRCLE = 'SHARE_CIRCLE',
  PERSON = 'PERSON',
  PEOPLE = 'PEOPLE',
  GROUP = 'GROUP',
  GROUP_REQUESt = 'GROUP_REQUEST',
  SCHEDULE = 'SCHEDULE',
  DRAFT = 'DRAFT',
  EMOJI = 'EMOJI',
  FILE = 'FILE',
  VIDEO = 'VIDEO',
  PHOTO = 'PHOTO',
  KARMA = 'karma',
  COMMENT = 'comment',
  EDIT = 'edit',
  TROFEU = 'trofeu',
  REJECTED = 'rejected',
  VERIFIED = 'verified',
  POST = 'post',
  CHALLENGE = 'challenge',
  QUESTION = 'question',
  SCHEDULED = 'scheduled',
  BOOKMARK = 'bookmark',
  FLAGGED = 'flagged',
  STARS = 'STARS',
  FRIENDS = 'FRIENDS',
  COPY = 'COPY',
  EMPTYPOST = 'empty_post_icon',
  PENDING = 'pending',
  GROUPBADGE = 'group_bade',
  ALERT = 'alert',
  WARNING = 'warning',
  ACCEPTED = 'accepted',
  DISCOVER = 'discover',
  INFO = 'info',
  RADIO = 'radio',
  RADIOSELECTED = 'radioSelected',
  CHECKBOX = 'checkbox',
  CHECKBOXSELECTED = 'checkboxSelected',
  ARTICLE = 'ARTICLE',
  AUDIO = 'AUDIO',
  POLL = 'POLL',
  SERIES = 'SERIES',
  SURVEY = 'SURVEY',
  VIDEO_CONTENT = 'VIDEO_CONTENT',
  SOCIAL_EVENT = 'social_event',
  VIDEOICON = 'videoIcon',
  CHECK = 'check',
  CLEAR = 'clear',
  STARMARK = 'starmark',
  UPLOAD = 'upload',
  EMPTY_EVENT = 'empty_event',
  LOCATION = 'location',
  DISCLAIMER = 'disclaimer',
  HIDE = 'hide',
  UNHIDE = 'unhide',
  DELETE = 'delete',
  SUBTRACT = 'subtract',
  NOTIFICATIONS = 'notifications',
  NOTIFICATIONS_OFF = 'notifications_off',
}

export default SvgIcons;
